export default (set, products, dimensions) => set((state) => ({ // Get the current state
  searchModelSKUs: {
    ...state.searchModelSKUs, // Copy existing data from searchModelSKUs
    products: products || [], // Set products, default to empty array
    dimensions: dimensions || [], // Set dimensions, default to empty array
  }
}),
false,
{ type: 'collection/updateSearchModelSkus', products, dimensions }
);
